import type { SupportedLanguage } from '@/app/types';

// 中文 10000 => 1万，105000 => 10.5万， 210000 => 21万
// 英文 1000 => 1K，10000 => 10K，105000 => 105K， 210000 => 210K
export const formatCount = (count: number, locale = 'en'): string => {
  const threshold = locale === 'zh' ? 10000 : 1000;
  const units = locale === 'zh' ? ['', '万', '亿', '万亿'] : ['', 'K', 'M', 'B', 'T'];

  // 小于阈值直接返回
  if (count < threshold) {
    return count.toString();
  }

  // 计算应使用的单位
  let unitIndex = 0;
  let value = count;

  while (value >= threshold && unitIndex < units.length - 1) {
    value /= threshold;
    unitIndex++;
  }

  // 小于10显示一位小数，否则取整
  if (value < 10) {
    return `${Math.floor(value * 10) / 10}${units[unitIndex]}`;
  }

  return `${Math.floor(value)}${units[unitIndex]}`;
};

/**
 * 模板页面的数字格式化
 * @param count 数字
 * @param locale 语言
 * @returns 格式化后的数字
 * 1-999 原始数字
 * 1000-9999 使用K保留一位小数
 * 10000-999999 中文：使用W保留一位小数，英文：使用K保留一位小数
 * >= 1000000 中文：使用W保留一位小数，英文：使用M保留一位小数
 */
export function formatCountForTemplate(count: number, locale: SupportedLanguage): string {
  const formatTruncate1Decimal = (num: number) => {
    const truncated = Math.floor(num * 10) / 10;
    return truncated.toFixed(1);
  };

  if (count < 1000) {
    return count.toString();
  }

  if (count < 10000) {
    return `${formatTruncate1Decimal(count / 1000)}K`;
  }

  if (count < 1000000) {
    if (locale === 'zh') {
      return `${formatTruncate1Decimal(count / 10000)}W`;
    }
    return `${formatTruncate1Decimal(count / 1000)}K`;
  }

  // ≥ 1,000,000
  if (locale === 'zh') {
    return `${formatTruncate1Decimal(count / 10000)}W`;
  }
  return `${formatTruncate1Decimal(count / 1000000)}M`;
}
